export class AppConsts {
    //static appBaseUrl: string;
    static readonly EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    static readonly PHONE_REGEXP = /^\d{3}-\d{3}-\d{4}/;
    static readonly NUMBER_REGEXP = /^[0-9]*$/;
}
